import apiClient from "@/utils/apiClient";

/**
 * Creates a new location row for IPA/VMC import, cloning address meta from source offer.
 * Retries with a suffixed description if the first POST conflicts.
 */
export async function createLocationFromImportedOffer(clientId, sourceOffer) {
    const sourceLocation = sourceOffer?.location || {};
    const sourceDescription = sourceLocation?.description || "Locație importată";
    const baseDescription = `${sourceDescription} (import oferta #${sourceOffer.id})`;
    const regionId =
        typeof sourceLocation?.region === "object"
            ? sourceLocation?.region?.id ?? sourceLocation?.region?.value ?? null
            : sourceLocation?.region ?? null;
    const subregionValue =
        typeof sourceLocation?.subregion === "object"
            ? sourceLocation?.subregion?.name ??
              sourceLocation?.subregion?.label ??
              sourceLocation?.subregion?.value ??
              ""
            : sourceLocation?.subregion || "";
    const payloadBase = {
        client_id: clientId,
        region_id: regionId,
        subregion: subregionValue,
        address: sourceLocation?.address || "",
    };

    for (let attempt = 0; attempt < 3; attempt++) {
        const description =
            attempt === 0
                ? baseDescription
                : `${baseDescription} ${Date.now().toString().slice(-4)}-${attempt}`;
        try {
            const response = await apiClient.post("/api/add_location/", {
                ...payloadBase,
                description,
            });
            return {
                id: response.data?.id,
                description,
            };
        } catch (error) {
            if (attempt === 2) {
                throw error;
            }
        }
    }
    return { id: null, description: null };
}
